import * as React from "react"

import { cn } from "@/lib/utils"

export type InputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> & {
  size?: 'sm' | 'md' | 'lg'
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, size = 'md', ...props }, ref) => {
    const sizeClasses =
      size === 'sm'
        ? 'h-9 text-xs file:text-xs'
        : size === 'lg'
        ? 'h-12 text-base file:text-base'
        : 'h-10 text-sm file:text-sm'

    return (
      <input
        type={type}
        className={cn(
          'flex w-full rounded-md border-2 border-input bg-white dark:bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 shadow-sm transition-colors',
          sizeClasses,
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'

export { Input }
